import { render, staticRenderFns } from "./VueDatatable.vue?vue&type=template&id=0c771220&scoped=true&"
import script from "./VueDatatable.vue?vue&type=script&lang=js&"
export * from "./VueDatatable.vue?vue&type=script&lang=js&"
import style0 from "./VueDatatable.vue?vue&type=style&index=0&id=0c771220&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c771220",
  null
  
)

export default component.exports